import { FC } from "react";
import type { OrderedItem } from "@/pages/OrderTracking/order-tracking.types";

export interface OrderedItemsProps {
  items: OrderedItem[];
}

export const OrderedItems: FC<OrderedItemsProps> = () => null;
